import { ClubRead, MyClubAccess } from "@/TS/Interfaces/global_interfaces";
import { CustomError } from "@/utils/init-globals";

export const isPresident = (
  club: Pick<ClubRead, "userRole"> | null | undefined,
): boolean => {
  return club?.userRole === "ROLE_PRESIDENT";
};

export const isMember = (
  club: Pick<ClubRead, "userRole"> | null | undefined,
): boolean => {
  return club?.userRole === "ROLE_MEMBER" || isPresident(club);
};

export const canAccessToClub = (
  myClubs: MyClubAccess[] | undefined,
  clubSlug: string,
): boolean => {
  return myClubs?.some((club) => club.slug === clubSlug) ?? false;
};

export function mergeObject<T>(...objs: Array<any>): T {
  if (objs.length < 2) {
    throw new CustomError(
      "Please enter at least one more object to merge them",
    );
  }
  return objs.reduce((acc, obj) => {
    return { ...acc, ...obj };
  }, {} as T);
}

export function removeEmptyFields(data: Record<string, unknown>) {
  Object.keys(data).forEach((key) => {
    if (data[key] === "" || data[key] == null) {
      delete data[key];
    }
    if (typeof data[key] === "object") {
      removeEmptyFields(data[key] as Record<string, unknown>);
    }
  });
}
